import { Flex, Form, Select, Space, Typography } from 'antd';

import { MultipleSelect, SearchButtons } from '@app/components';
import { PREFIX } from '@app/constants';
import {
  useBranchIndicatorsReport,
  useBranchIndicatorsReportEffects,
} from '@app/pages/Analytics/BranchIndicators/hooks';
import { BranchIndicatorsReportTable } from '@app/pages/Analytics/BranchIndicators/ui/BranchIndicatorsReportTable';
import {
  MONTHS,
  YEARS,
  CURRENT_MONTH,
  CURRENT_YEAR,
} from '@app/pages/Analytics/data';

import '@pages/Analytics/BranchIndicators/styles/BranchIndicatorsReport.desktop.scss';

const { Text } = Typography;
const { Item } = Form;

export const BranchIndicatorsReport = () => {
  const {
    handleReset,
    form,
    handleSubmitForm,
    isGetBranchIndicatorsLoading,
    allBranches,
    setAllBranches,
    tableData,
    selectedBranches,
    setSelectedBranches,
    handleSearchData,
  } = useBranchIndicatorsReport();
  useBranchIndicatorsReportEffects({
    setAllBranches,
    handleSearchData,
  });

  return (
    <div className={`${PREFIX}branch-indicators-report`}>
      <Form
        form={form}
        onFinish={handleSubmitForm}
        initialValues={{
          filterMonth: CURRENT_MONTH.value,
          filterYear: CURRENT_YEAR,
        }}
      >
        <Space
          className="content-header-space"
          direction="vertical"
          size="large"
        >
          <Space size="large" align="baseline">
            <Text strong>Период:</Text>
            <Item name="filterMonth">
              <Select
                placeholder="Выбор месяца"
                popupMatchSelectWidth={false}
                options={MONTHS}
                className="filters-select"
              />
            </Item>
            <Item name="filterYear">
              <Select
                placeholder="Выбор года"
                popupMatchSelectWidth={false}
                options={YEARS}
                className="filters-select"
              />
            </Item>
          </Space>
          <Flex justify="space-between">
            <MultipleSelect
              className="user-selector"
              placeholder="Все филиалы"
              allOptions={allBranches}
              width={100}
              selectedOption={selectedBranches}
              setSelectedOptions={setSelectedBranches}
            />
            <Flex justify="space-between">
              <SearchButtons
                className="desktop-buttons"
                resetAll={handleReset}
                showData={form.submit}
              />
            </Flex>
          </Flex>

          <BranchIndicatorsReportTable
            isLoading={isGetBranchIndicatorsLoading}
            tableData={tableData}
          />
        </Space>
      </Form>
    </div>
  );
};
